import Link from 'next/link';
import { ICON_ONLY_SVG, MAIN_LOGO_SVG } from '@/lib/brandAssets';

const SIZES = {
  sm: { iconW: 40, iconH: 40, logoW: 180, logoH: 52 },
  md: { iconW: 44, iconH: 44, logoW: 220, logoH: 64 },
  lg: { iconW: 48, iconH: 48, logoW: 250, logoH: 72 },
};

/**
 * @param {'responsive' | 'wordmark' | 'icon'} mode
 * - responsive: icononly on mobile, main-logo on sm+
 * - wordmark: main-logo everywhere (footer, hero cards)
 * - icon: icononly everywhere (small badges)
 */
export default function SiteLogo({
  href = '/',
  size = 'md',
  mode = 'responsive',
  variant = 'default',
  className = '',
  priority = false,
  width,
  height,
  iconWidth,
  iconHeight,
}) {
  const s = SIZES[size] || SIZES.md;
  const imgClass = variant === 'light' ? 'brightness-0 invert' : '';
  const logoWidth = width || s.logoW;
  const logoHeight = height || s.logoH;
  const iconOnlyWidth = iconWidth || s.iconW;
  const iconOnlyHeight = iconHeight || s.iconH;

  const showIcon = mode === 'icon' || mode === 'responsive';
  const showWordmark = mode === 'wordmark' || mode === 'responsive';
  const iconClass = mode === 'responsive' ? 'block sm:hidden' : 'block';
  const wordmarkClass = mode === 'responsive' ? 'hidden sm:block' : 'block';

  return (
    <Link
      href={href}
      aria-label="VisaProofs"
      className={`inline-flex shrink-0 items-center ${className}`}
    >
      {showIcon && (
        <img
          src={ICON_ONLY_SVG}
          alt=""
          width={iconOnlyWidth}
          height={iconOnlyHeight}
          className={`${iconClass} ${imgClass}`}
          fetchPriority={priority ? "high" : undefined}
          loading={priority ? "eager" : "lazy"}
          style={{ height: 'auto' }}
        />
      )}
      {showWordmark && (
        <img
          src={MAIN_LOGO_SVG}
          alt=""
          width={logoWidth}
          height={logoHeight}
          className={`${wordmarkClass} ${imgClass} h-9 lg:h-11`}
          fetchPriority={priority ? "high" : undefined}
          loading={priority ? "eager" : "lazy"}
          style={{ width: 'auto' }}
        />
      )}
    </Link>
  );
}
